module.exports = __webpack_public_path__ + "img/ic_workllamalogo.df19d377.png";